$(document).ready(function () {
    $('.search-book').autocomplete({
        source: function (request, response) {
            /*$('#form-update-authors').trigger("reset")
            $('.item-country').val('')
            $('.item-country').trigger("chosen:updated")
            $('.item-avatar').attr('src', '')*/

            $.ajax({
                url: '/admin/book/search',
                type: 'POST',
                dataType: 'json',
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                },
                data: {
                    term: request.term
                },
                success: function (data) {


                    response($.map(data, function (item) {
                        showTitle = item.title
                        return {
                            label: showTitle,
                            value: item.title,
                            id: item.id,
                        }
                    }))
                }
            });
        },
        select: function (event, ui) {
            $(".item-individual-article_id").val(ui.item.id)
            $(".item-individual-title-book").val(ui.item.value)
        }
    })
})
